import axios from "axios";

import getUrlPrefix from "~/components/cms/helpers/getUrlPrefix";

export function useCachedCmsElementsFromCategory() {
    const prefix = getUrlPrefix();
    const {
        getLanguageIdFromCode,
    } = useInternationalization();

    const languageId = getLanguageIdFromCode(
        prefix ? prefix : 'de-DE',
    );
    const loadCmsElementsFromCategory = async (categoryId: string, withChildren: boolean = false) => {
        let storeApiUrl = '';
        if (withChildren) {
            storeApiUrl = getOrigin() + "/api/cached/" + languageId + "/cms/elements/category/childs/" + categoryId;
        } else {
            storeApiUrl = getOrigin() + "/api/cached/" + languageId + "/cms/elements/category/main/" + categoryId;
        }
        const response = await axios.post(storeApiUrl);

        return response.data;
    }
    return {
        loadCmsElementsFromCategory
    }
}

function getOrigin(): string | undefined {
    let origin = "";
    const nuxtApp = useNuxtApp();
    const isDeV = process.env.NODE_ENV !== 'production';

    if (import.meta.server) {
        if (nuxtApp.ssrContext?.event.node.req.headers.host !== "undefined") {
            const location = isDeV ? "http://" : "https://"; // in dev mode we need to use http
            const host = nuxtApp.ssrContext?.event.node.req.headers.host;
            origin = location + host
        }
    } else {
        origin = window.location.origin;
    }

    return origin;
}